<template>
  <div>
    <section class="philosophy">
      <div class="philosophy-inner">
        <div>
          <div class="philosophy-title">{{ $t('philosophy.title') }}</div>
          <p>{{ $t('philosophy.sub') }}</p>
        </div>
        <button class="btn-enter" @click="$router.push('/assessment')">{{ $t('philosophy.btn') }} <img src="../assets/arrow-blue@2x.png" style="width: 20px; height: auto;"></button>
      </div>
    </section>
    <section id="how" class="how-section">
      <div class="how-inner">
        <h2>{{ $t('howTo.title') }}</h2>
        <div class="title-line" :class="{ 'title-line-en': $i18n.locale === 'en' }"></div>
        <p class="desc">{{ $t('howTo.desc1') }}</p>
        <p class="desc">{{ $t('howTo.desc2') }}</p>
        <div class="steps">
          <div class="step" v-for="s in steps" :key="s.num" :class="'step-' + s.num">
            <div class="num-circle">{{ s.num }}</div>
            <div :class="'step-card-' + s.num">
              <h3>{{ $t('howTo.scenario') }} {{ s.letter }}</h3>
              <p class="scenario">{{ $t('howTo.scenario' + s.letter) }}</p>
              <p class="step-desc">{{ $t('howTo.desc' + s.letter) }}</p>
              <div class="minutes">≈ {{ s.minutes }} {{ $t('howTo.minutes') }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HowToTake',
  data() {
    return {
      steps: [
        { num: 1, letter: 'A', minutes: 5},
        { num: 2, letter: 'B', minutes: 12},
        { num: 3, letter: 'C', minutes: 12}
      ]
    }
  }
}
</script>

<style scoped>
.philosophy { background: url('../assets/header-bg@2x.png') center/cover no-repeat; color: #fff; padding: 28px 40px; }
.philosophy-inner { max-width: 1100px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; }
.philosophy-title { font-size: 22px; font-weight: 700; margin-bottom: 4px; }
.philosophy p { font-size: 13px; opacity: 0.85; }
.btn-enter {
  background: #fff; color: #2b7de9; border: none; padding: 10px 28px; border-radius: 4px;
  font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap; transition: box-shadow 0.2s;
}
.btn-enter:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
.how-section { background: url('../assets/reading-group-bg@2x.png') center/cover no-repeat; padding: 72px 40px; color: #333; position: relative; }
.how-section::before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; }
.how-inner { max-width: 1100px; margin: 0 auto; text-align: center; position: relative; z-index: 1; }
h2 { font-size: 28px; font-weight: 700; margin-bottom: 8px; color: #1a1a1a; }
.title-line { width: 200px; height: 10px; background: linear-gradient(to right, #2b7de9, #fff); margin: -18px auto 40px; }
.title-line-en { width: 400px; height: 10px; background: linear-gradient(to right, #2b7de9, #fff); margin: -18px auto 40px; }
.desc { font-size: 14px; color: #555; margin-bottom: 4px; }
.steps { display: flex; gap: 28px; margin-top: 48px; justify-content: center; }
.step { flex: 1; max-width: 300px; text-align: center; }
.num-circle {
  width: 48px; height: 48px; border-radius: 50%; font-size: 20px; font-weight: 700;
  display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; border: 2px solid;
}
.step-1 .num-circle { border-color: #fff; color: #1a1a1a; background-color: #e1e0f5 }
.step-2 .num-circle { border-color: #fff; color: #1a1a1a; background-color: #dde8f7 }
.step-3 .num-circle { border-color: #fff; color: #1a1a1a; background-color: #caf1ee}
.step-card-1 {  background: linear-gradient(to top, #cec5f0, #e1e0f5); border-radius: 12px; padding: 24px 20px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); }
.step-card-2 {  background: linear-gradient(to top, #bac8e9, #dde8f7); border-radius: 12px; padding: 24px 20px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); }
.step-card-3 {  background: linear-gradient(to top, #9bdfdd, #caf1ee); ; border-radius: 12px; padding: 24px 20px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); }
h3 { font-size: 16px; font-weight: 600; margin-bottom: 4px; color: #1a1a1a; }
.scenario { font-size: 13px; font-weight: 600; color: #2b7de9; margin-bottom: 12px; }
.step-desc { font-size: 13px; color: #555; line-height: 1.6; margin-bottom: 16px; }
.minutes { font-size: 15px; font-weight: 700; color: #1a1a1a; }
@media (max-width: 768px) {
  .steps { flex-direction: column; align-items: center; }
  .philosophy-inner { flex-direction: column; gap: 16px; text-align: center; }
  .philosophy { padding: 24px 20px; }
  .how-section { padding: 48px 20px; }
}
</style>
